// extracted by mini-css-extract-plugin
module.exports = {"questionVoteBox":"Bs","upvote":"Cs","downvote":"Ds","numVotes":"Es","votesDescription":"Fs","report":"Gs","voted":"Hs","answerVoteBox":"Is","justReported":"Js"};